<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  appendTo="body"
  [baseZIndex]="10000"
  [style]="{ width: '480px', maxWidth: '96vw' }"
  [contentStyle]="{ padding: '0' }"
  styleClass="transferencia-confirm-dialog"
  (onHide)="onCancelar()">

  <ng-template pTemplate="header">
    <div class="transferencia-header">
      <div class="transferencia-header-left">
        <div class="transferencia-header-icon">
          <i class="pi pi-users"></i>
        </div>
        <div class="transferencia-header-text">
          <span class="transferencia-header-title">Transferir time(s) entre gestores?</span>
        </div>
      </div>
      <button
        type="button"
        class="transferencia-close-btn"
        (click)="onCancelar()"
        [disabled]="loading"
        aria-label="Fechar">
        <i class="pi pi-times"></i>
      </button>
    </div>
  </ng-template>

  <div class="transferencia-body" *ngIf="conflitos?.length">
    <div class="transferencia-content">
      <div class="transferencia-info-icon">
        <i class="pi pi-info-circle"></i>
      </div>
      <p class="transferencia-mensagem">
        <ng-container *ngIf="pluralConflitos; else singularMsg">
          Os times abaixo ja pertencem a outros gestores.
          Confirmar a transferencia?
        </ng-container>
        <ng-template #singularMsg>
          O time abaixo ja pertence a outro gestor.
          Confirmar a transferencia?
        </ng-template>
      </p>
    </div>

    <ul class="transferencia-lista" role="list">
      <li class="transferencia-item" *ngFor="let c of conflitos; trackBy: trackByTimeId">
        <div class="transferencia-item-time">
          <i class="pi pi-users transferencia-item-icon"></i>
          <span class="transferencia-item-nome">{{ c.timeNome }}</span>
        </div>
        <div class="transferencia-item-gestor">
          atualmente com <strong>{{ c.gestorAtualNome }}</strong>
        </div>
      </li>
    </ul>

    <div class="transferencia-footer">
      <button
        type="button"
        pButton
        class="transferencia-cancel-btn"
        label="Cancelar"
        [disabled]="loading"
        (click)="onCancelar()">
      </button>
      <button
        type="button"
        pButton
        icon="pi pi-arrow-right-arrow-left"
        class="transferencia-confirm-btn"
        label="Sim, transferir"
        [loading]="loading"
        (click)="onConfirmar()">
      </button>
    </div>
  </div>
</p-dialog>
